import React, { useEffect, useState } from 'react';
import { bucketlink2 } from '../../config/fire-conf';
import { toast } from 'react-toastify';
import { Upload } from 'antd';
import ImgCrop from 'antd-img-crop';
import AddOutlinedIcon from '@material-ui/icons/AddOutlined';
import { getMaxNftSize, getMaxNftBgSize } from '../../services/common-query';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { writeBatch, doc } from 'firebase/firestore/lite';
import { firebaseFireStore } from '../../config/firebaseFirestore';

import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { nftFirebaseStorage } from '../../config/firebaseStorage';

let maxNftSize = {
  val: 0,
  mb: 0,
};

let maxNftBgSize = {
  val: 0,
  mb: 0,
};

export default function SettingsTab(props) {
  const [artistDetails, setartistDetails] = useState({
    name: '',
    bio: '',
    facebook: '',
    instagram: '',
    tiktok: '',
    twitter: '',
    followers: 0,
    following: 0,
  });
  const [backgroundImage, setbackgroundImage] = useState([]);
  const [profileImage, setprofileImage] = useState([]);
  const [loadingUpdateBtn, setloadingUpdateBtn] = useState(false);
  console.log('profileImage', backgroundImage);
  useEffect(() => {
    if (props.artistProfile) {
      setartistDetails({ ...props.artistProfile });
      getArtistProfile();
    }
  }, [props.artistProfile]);

  useEffect(() => {
    getMaxImgSize();
  }, []);

  const getMaxImgSize = async () => {
    maxNftSize = await getMaxNftSize();
    maxNftBgSize = await getMaxNftBgSize();
  };

  const getArtistProfile = async () => {
    let artistObj = props.artistProfile;

    console.log('artistObj', artistObj);
    if (artistObj && artistObj.thumbnailImage) {
      console.log('artistObj.thumbnailImage', artistObj.thumbnailImage);

      let arr = [];
      arr.push({
        uid: 'img-seller-background',
        name: 'image-bg.png',
        status: 'done',
        url: artistObj.thumbnailImage + '_1920x1920?alt=media&t=' + Date.now(),
        uploaded: true,
      });
      setbackgroundImage(arr);
    } else {
      setbackgroundImage([]);
    }

    if (artistObj && artistObj.photoUrl) {
      let arr = [];
      arr.push({
        uid: 'img-seller-profile',
        name: 'image-profile.png',
        status: 'done',
        url: artistObj.photoUrl + '_250x250?alt=media&t=' + Date.now(),
        uploaded: true,
      });
      setprofileImage(arr);
    } else {
      setprofileImage([]);
    }
  };

  const updateArtistProfile = async (e) => {
    e.preventDefault();
    // return console.log(backgroundImage[0].url,"imgBgEle.url",profileImage[0].url,"imgProfileEle.url" )
    try {
      setloadingUpdateBtn(true);

      if (!backgroundImage || backgroundImage.length === 0) {
        //validating image uploadation
        toast.error(`Please upload MusicArtist background image!`, {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setloadingUpdateBtn(false);
        return null;
      }

      if (!profileImage || profileImage.length === 0) {
        //validating image uploadation
        toast.error(`Please upload MusicArtist profile image!`, {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setloadingUpdateBtn(false);
        return null;
      }
      let artistDetailsObj = { ...artistDetails };

      artistDetailsObj.lowerCaseName = artistDetailsObj.name.toLowerCase();

      //uploading bg image
      let imgBgUrl = null;
      let imgBgEle = backgroundImage[0];
      if (imgBgEle.uploaded) {
        imgBgUrl = imgBgEle.url;
      } else {
        const uploadTask = ref(
          nftFirebaseStorage,
          'artistBg/' + props.artistId,
        );
        await uploadBytes(uploadTask, backgroundImage[0].originFileObj);
        await getDownloadURL(uploadTask).then((url) => {
          let enewUrl = url.split('?alt=media');
          imgBgUrl = enewUrl[0];
          artistDetailsObj.thumbnailImage = imgBgUrl;
        });
      }

      //uploading profile image
      let imgProfileUrl = '';
      let imgProfileEle = profileImage[0];
      if (imgProfileEle.uploaded) {
        imgProfileUrl = imgProfileEle.url;
      } else {
        const uploadTask2 = ref(
          nftFirebaseStorage,

          'artistProfile/' + props.artistId,
        );

        await uploadBytes(uploadTask2, profileImage[0].originFileObj);
        await getDownloadURL(uploadTask2).then((url) => {
          let enewUrl = url.split('?alt=media');
          imgProfileUrl = enewUrl[0];
          artistDetailsObj.photoUrl = imgProfileUrl;
        });
        // imgProfileUrl = `${bucketlink2}artistProfile%2F${props.artistId}`
      }

      let batch = writeBatch(firebaseFireStore);

      let artistDetailsRef = doc(
        firebaseFireStore,
        'musicartArtists',
        props.artistId,
      );

      batch.update(artistDetailsRef, artistDetailsObj);

      await batch.commit();
      // Router.relo
      setloadingUpdateBtn(false);
      toast.success('MusicArtist profile updated successfully', {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        zIndex: 2147483641,
      });

      props.setartistProfile(artistDetailsObj);
      props.forceUpdate();
    } catch (err) {
      console.log('err', err);
      // console.log("err", err);
      toast.error('An error occured', {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        zIndex: 2147483641,
      });
      setloadingUpdateBtn(false);
    }
  };

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess('ok');
    }, 0);
  };

  const onChangeBgImage = async ({ fileList: newFileList }) => {
    if (newFileList[0] && newFileList[0].size > maxNftBgSize.val) {
      toast.error(`Image must be smaller than ${maxNftBgSize.mb} MB`, {
        position: 'bottom-left',
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        zIndex: 2147483641,
      });
    } else {
      setbackgroundImage(newFileList);
    }
  };

  const onChangeProfileImage = async ({ fileList: newFileList }) => {
    if (newFileList[0] && newFileList[0].size > maxNftSize.val) {
      toast.error(`Image must be smaller than ${maxNftSize.mb} MB`, {
        position: 'bottom-left',
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        zIndex: 2147483641,
      });
    } else {
      setprofileImage(newFileList);
    }
  };

  const onPreview = async (file) => {
    let src = file.url;
    console.log('srcx', src);
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow.document.write(image.outerHTML);
  };

  return (
    <div className="seller__tab_pane" role="tabpanel">
      <div className="seller__tab_content">
        <form
          key="artist-settings-from"
          onSubmit={updateArtistProfile}
          className="sign__form--mint"
          style={{ marginTop: 10 }}
        >
          <div className="row">
            {/* //details */}
            <div className="w-full px-4">
              <h4 className="sign__title">MusicArtist Details</h4>
            </div>
            <div className="w-full px-4">
              <div className="sign__group">
                <label className="sign__label" htmlFor="artist-name">
                  MusicArtist Name <span className="text-red-500">*</span>
                </label>
                <input
                  id="artist-name"
                  type="text"
                  className="sign__input"
                  placeholder="e.g. 'John Lee'"
                  required
                  value={artistDetails.name}
                  onChange={(e) => {
                    let modifiedObj = {
                      ...artistDetails,
                    };
                    modifiedObj.name = e.target.value;
                    setartistDetails(modifiedObj);
                  }}
                  pattern=".*\S+.*"
                  title="This field is required"
                />
                {artistDetails && artistDetails.name.length > 0 && (
                  <button
                    type="button"
                    onClick={() => {
                      let modifiedObj = {
                        ...artistDetails,
                      };
                      modifiedObj.name = '';
                      setartistDetails(modifiedObj);
                    }}
                    className="close_icon"
                  >
                    <HighlightOffIcon />
                  </button>
                )}
              </div>
            </div>

            <div className="w-full px-4">
              <div className="sign__group">
                <label className="sign__label" htmlFor="artist-bio">
                  MusicArtist Bio <span className="text-red-500">*</span>
                </label>
                <div className="sign__group">
                  <textarea
                    id="artist-bio"
                    className="sign__textarea close_icon_scroll"
                    placeholder="MusicArtist details"
                    value={artistDetails.bio}
                    onChange={(e) => {
                      let modifiedObj = {
                        ...artistDetails,
                      };
                      modifiedObj.bio = e.target.value;
                      setartistDetails(modifiedObj);
                    }}
                    required
                  ></textarea>
                  {artistDetails &&
                    artistDetails.bio &&
                    artistDetails.bio.length > 0 && (
                      <button
                        type="button"
                        onClick={() => {
                          let modifiedObj = {
                            ...artistDetails,
                          };
                          modifiedObj.bio = '';
                          setartistDetails(modifiedObj);
                        }}
                        className="close_icon"
                        style={{
                          top: '0%',
                        }}
                      >
                        <HighlightOffIcon />
                      </button>
                    )}
                </div>
              </div>
            </div>
            <div className="w-full lg:w-6/12 px-4">
              <div className="sign__group">
                <label className="sign__label">
                  MusicArtist Background Image{' '}
                  <span className="text-red-500">*</span>
                </label>

                <ImgCrop rotate aspect={2 / 1}>
                  <Upload
                    customRequest={dummyRequest}
                    listType="picture-card"
                    fileList={backgroundImage}
                    onChange={onChangeBgImage}
                    onPreview={onPreview}
                  >
                    {backgroundImage.length < 1 && <AddOutlinedIcon />}
                  </Upload>
                </ImgCrop>
              </div>
            </div>

            <div className="w-full lg:w-6/12 px-4">
              <div className="sign__group">
                <label className="sign__label">
                  MusicArtist Profile Image{' '}
                  <span className="text-red-500">*</span>
                </label>

                <ImgCrop rotate>
                  <Upload
                    customRequest={dummyRequest}
                    listType="picture-card"
                    fileList={profileImage}
                    onChange={onChangeProfileImage}
                    onPreview={onPreview}
                  >
                    {profileImage.length < 1 && <AddOutlinedIcon />}
                  </Upload>
                </ImgCrop>
              </div>
            </div>

            {/*  */}
            <div className="w-full px-4 mt-4">
              <h4 className="sign__title">
                Artist Profiles
                <span className="sign__label" style={{ paddingLeft: 10 }}>
                  (optional)
                </span>
              </h4>
            </div>
            <div className="w-full md:w-6/12 px-4">
              <div className="sign__group">
                <label className="sign__label" htmlFor="artist-twitter">
                  Spotify
                </label>
                <input
                  id="artist-twitter"
                  type="text"
                  className="sign__input"
                  value={artistDetails.spotify}
                  onChange={(e) => {
                    let modifiedObj = {
                      ...artistDetails,
                    };
                    modifiedObj.spotify = e.target.value;
                    setartistDetails(modifiedObj);
                  }}
                  placeholder="e.g. https://open.spotify.com/artist/..."
                />
                {artistDetails &&
                  artistDetails.spotify &&
                  artistDetails.spotify.length > 0 && (
                    <button
                      type="button"
                      onClick={() => {
                        let modifiedObj = {
                          ...artistDetails,
                        };
                        modifiedObj.spotify = '';
                        setartistDetails(modifiedObj);
                      }}
                      className="close_icon"
                    >
                      <HighlightOffIcon />
                    </button>
                  )}
              </div>
            </div>
            <div className="w-full md:w-6/12 px-4">
              <div className="sign__group">
                <label className="sign__label" htmlFor="artist-twitter">
                  Apple
                </label>
                <input
                  id="artist-twitter"
                  type="text"
                  className="sign__input"
                  value={artistDetails.apple}
                  onChange={(e) => {
                    let modifiedObj = {
                      ...artistDetails,
                    };
                    modifiedObj.apple = e.target.value;
                    setartistDetails(modifiedObj);
                  }}
                  placeholder="e.g. https://music.apple.com/gb/artist/..."
                />
                {artistDetails &&
                  artistDetails.apple &&
                  artistDetails.apple.length > 0 && (
                    <button
                      type="button"
                      onClick={() => {
                        let modifiedObj = {
                          ...artistDetails,
                        };
                        modifiedObj.apple = '';
                        setartistDetails(modifiedObj);
                      }}
                      className="close_icon"
                    >
                      <HighlightOffIcon />
                    </button>
                  )}
              </div>
            </div>
            <div className="w-full md:w-6/12 px-4">
              <div className="sign__group">
                <label className="sign__label" htmlFor="artist-aurovine">
                  Aurovine
                </label>
                <input
                  id="artist-aurovine"
                  type="text"
                  className="sign__input"
                  value={artistDetails.aurovine}
                  onChange={(e) => {
                    let modifiedObj = {
                      ...artistDetails,
                    };
                    modifiedObj.aurovine = e.target.value;
                    setartistDetails(modifiedObj);
                  }}
                  placeholder="e.g. https://www.aurovine.com/artistProfile/..."
                />
                {artistDetails &&
                  artistDetails.aurovine &&
                  artistDetails.aurovine.length > 0 && (
                    <button
                      type="button"
                      onClick={() => {
                        let modifiedObj = {
                          ...artistDetails,
                        };
                        modifiedObj.aurovine = '';
                        setartistDetails(modifiedObj);
                      }}
                      className="close_icon"
                    >
                      <HighlightOffIcon />
                    </button>
                  )}
              </div>
            </div>

            {/* //Urls links */}
            <div className="w-full px-4 mt-4">
              <h4 className="sign__title">
                Social Profiles
                <span className="sign__label" style={{ paddingLeft: 10 }}>
                  (optional)
                </span>
              </h4>
            </div>

            <div className="w-full md:w-6/12 px-4">
              <div className="sign__group">
                <label className="sign__label" htmlFor="artist-twitter">
                  Twitter Profile
                </label>
                <input
                  id="artist-twitter"
                  type="text"
                  className="sign__input"
                  value={artistDetails.twitter}
                  onChange={(e) => {
                    let modifiedObj = {
                      ...artistDetails,
                    };
                    modifiedObj.twitter = e.target.value;
                    setartistDetails(modifiedObj);
                  }}
                  placeholder="e.g. https://twitter.com/username"
                />
                {artistDetails && artistDetails.twitter.length > 0 && (
                  <button
                    type="button"
                    onClick={() => {
                      let modifiedObj = {
                        ...artistDetails,
                      };
                      modifiedObj.twitter = '';
                      setartistDetails(modifiedObj);
                    }}
                    className="close_icon"
                  >
                    <HighlightOffIcon />
                  </button>
                )}
              </div>
            </div>
            <div className="w-full md:w-6/12 px-4">
              <div className="sign__group">
                <label className="sign__label" htmlFor="artist-tiktok-profile">
                  Tiktok Profile
                </label>
                <input
                  id="artist-tiktok-profile"
                  type="text"
                  className="sign__input"
                  placeholder="e.g. https://tiktok.com/@username"
                  value={artistDetails.tiktok}
                  onChange={(e) => {
                    let modifiedObj = {
                      ...artistDetails,
                    };
                    modifiedObj.tiktok = e.target.value;
                    setartistDetails(modifiedObj);
                  }}
                />
                {artistDetails && artistDetails.tiktok.length > 0 && (
                  <button
                    type="button"
                    onClick={() => {
                      let modifiedObj = {
                        ...artistDetails,
                      };
                      modifiedObj.tiktok = '';
                      setartistDetails(modifiedObj);
                    }}
                    className="close_icon"
                  >
                    <HighlightOffIcon />
                  </button>
                )}
              </div>
            </div>
            <div className="w-full md:w-6/12 px-4">
              <div className="sign__group">
                <label className="sign__label" htmlFor="artist-Insta">
                  Instagram Profile
                </label>
                <input
                  id="artist-Insta"
                  type="text"
                  className="sign__input"
                  placeholder="e.g. https://www.instagram.com/username"
                  value={artistDetails.instagram}
                  onChange={(e) => {
                    let modifiedObj = {
                      ...artistDetails,
                    };
                    modifiedObj.instagram = e.target.value;
                    setartistDetails(modifiedObj);
                  }}
                />
                {artistDetails && artistDetails.instagram.length > 0 && (
                  <button
                    type="button"
                    onClick={() => {
                      let modifiedObj = {
                        ...artistDetails,
                      };
                      modifiedObj.instagram = '';
                      setartistDetails(modifiedObj);
                    }}
                    className="close_icon"
                  >
                    <HighlightOffIcon />
                  </button>
                )}
              </div>
            </div>
            <div className="w-full md:w-6/12 px-4">
              <div className="sign__group">
                <label className="sign__label" htmlFor="artist-facebook">
                  Facebook Profile
                </label>
                <input
                  id="artist-facebook"
                  type="text"
                  className="sign__input"
                  placeholder="e.g. https://www.facebook.com/username"
                  value={artistDetails.facebook}
                  onChange={(e) => {
                    let modifiedObj = {
                      ...artistDetails,
                    };
                    modifiedObj.facebook = e.target.value;
                    setartistDetails(modifiedObj);
                  }}
                />
                {artistDetails && artistDetails.facebook.length > 0 && (
                  <button
                    type="button"
                    onClick={() => {
                      let modifiedObj = {
                        ...artistDetails,
                      };
                      modifiedObj.facebook = '';
                      setartistDetails(modifiedObj);
                    }}
                    className="close_icon"
                  >
                    <HighlightOffIcon />
                  </button>
                )}
              </div>
            </div>

            {/* //update btn */}
            <div className="w-full xl:w-3/12 px-4 mt-2">
              {loadingUpdateBtn ? (
                <div
                  className="flex justify-center	w-full sign__btn"
                  style={{ backgroundColor: 'transparent' }}
                >
                  <i className="fas fa-circle-notch animate-spin text-blueGray-800 mx-auto"></i>
                </div>
              ) : (
                <button type="submit" className="sign__btn">
                  Update Profile
                </button>
              )}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
